import PropTypes from 'prop-types';
import { parseISO } from 'date-fns/esm/fp';
import cc from 'classcat';

import { differenceInWeeksRounded } from '../../lib/date-fns';
import { formatMonthDay } from '../../lib/formatters/temporal';

import styles from './styles.module.scss';

const GameDateRange = ({
  dateStyle,
  duration,
  hideDuration,
  start,
  end,
  className,
}) => {
  start = parseISO(start);
  end = parseISO(end);

  const amount = duration
    ? duration.value
    : differenceInWeeksRounded(start, end);
  const period = duration ? duration.unit : 'week';

  return (
    <div className={className}>
      <span className={cc([styles.dates, dateStyle])}>
        {formatMonthDay(start)} &ndash; {formatMonthDay(end)}
      </span>{' '}
      {!hideDuration && (
        <span>
          &middot; {amount} {period} game
        </span>
      )}
    </div>
  );
};

GameDateRange.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default GameDateRange;
